import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { SCHEDULE_API_ROUTES } from "../utils/scheduleApiRoutes";
import { authJsonHeaders, buildApiError, parseJson } from "./apiHelpers";

const BASE = SCHEDULE_API_ROUTES.schedules;

export async function getSchedules({ scope = "self" } = {}) {
  const params = scope ? `?scope=${encodeURIComponent(scope)}` : "";
  const res = await authFetch(`${BASE}${params}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch schedules");
  return data;
}

export async function getScheduleById(id) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch schedule");
  return data;
}

export async function createSchedule(body, csrfToken) {
  const res = await authFetch(BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to create schedule");
  return data;
}

export async function updateSchedule(id, body, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to update schedule");
  return data;
}

export async function markScheduleCompleted(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}/complete`, {
    method: "PATCH",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to mark schedule completed");
  return data;
}

export async function cancelSchedule(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}/cancel`, {
    method: "PATCH",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to cancel schedule");
  return data;
}

export async function deleteSchedule(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to delete schedule");
  return data;
}

export async function exportSchedules() {
  const res = await authFetch(`${BASE}/export`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to export schedules");
  return data;
}

export function normalizeStaffSearchResponse(payload) {
  if (Array.isArray(payload)) return { data: payload };
  if (Array.isArray(payload?.data)) return { data: payload.data };
  return { data: [] };
}

export async function searchScheduleStaff(query) {
  const q = String(query ?? "").trim();
  if (!q) return { data: [] };
  const res = await authFetch(
    `${SCHEDULE_API_ROUTES.staffSearch}?q=${encodeURIComponent(q)}`,
    {
      credentials: "include",
      headers: buildAuthHeaders(),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to search staff");
  return normalizeStaffSearchResponse(data);
}
